import { Spin } from "antd";

export default function SpinPage({ loading, children }) {
  return <div>{loading ? <Spin /> : children}</div>;
}
